<template>
  <div :class="classes">
      <pt-page-title title="商品二维码" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      </pt-page-title>
      <pt-sub-title title="二维码详情列表"></pt-sub-title>
      <pt-qr-code-detail-table :id="id" :tableLabels="tableLabels" :paramsData="paramsData">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="reviewQrCode(scope.row)">预览</el-button>
                  <el-button type="text" @click="downloadQrCode(scope.row)">下载</el-button>
              </template>
          </el-table-column>
      </pt-qr-code-detail-table>
      <el-dialog  :visible.sync="is_review" @close="closeDialog" :class="$style['review-qr-code-dialog']">
          <img :src="revieQrCodeUrl"/>
      </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import ptQrCodeDetailTable from './pt-qr-code-detail-table/withData.vue'
import { qrCodeDetailLabels } from '../goods-qr-code-options.js'
const prefixCls = 'pt-goods-qr-code-detail'
export default {
  name: 'pt-goods-qr-code-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptQrCodeDetailTable
  },
  props: {
    id: {
      type: String,
      default: null
    },
    revieQrCodeUrl: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      paramsData: {
      },
      searchKey: null,
      tableLabels: qrCodeDetailLabels,
      is_review: false,
      publicResourcesUrl: this.$publicResourcesUrl
    }
  },
  watch: {
    revieQrCodeUrl (val) {
      if (val) {
        console.log('revieQrCodeUrl', val)
        this.is_review = true
      }
    }
  },
  methods: {
    closeDialog () {

    },
    search (val) {
      this.$set(this.paramsData, 'searchKey', val)
      this.searchKey = val
    },
    emptySearch () {
      this.$set(this.paramsData, 'searchKey', null)
      this.searchKey = null
    },
    downloadQrCode (row) {
    //   this.$emit('downloadQrCodeDetail', row.id)
      window.open(this.$publicResourcesUrlDownload + row.qrCodeUrl)
    },
    reviewQrCode (row) {
      this.$emit('getQrCodeUrl', row.qrCodeUrl)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.review-qr-code-dialog{
    :global
    .el-dialog{
    background: rgba(255,255,255,0);
    box-shadow:none;
    width: auto;
    :global
    .el-dialog__headerbtn{
        right: 0;
        .el-dialog__close{
            color: #fff;
            font-size:25px;
            font-weight: 600
        }
    }
    }

}
</style>
